export default (token = [], action) => {
    switch (action.type) {
        case 'FETCH_TOKEN':
            return action.payload;
        default:
            return token;
    }
}